import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix Leaflet default icon paths for webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

var contacts = {
  init: function () {
    const mapEl = $("#map-wrap");
    if (mapEl.length) {
      contacts.map.init();
    }
  },

  map: {
    lat: false,
    lng: false,
    pin: false,
    zoom: 16,
    mapInstance: null,
    mapCenter: null,
    isResizing: false,

    init: function () {
      contacts.map.render_map();
    },

    zoomControl: function (map) {
      // Create custom zoom control container
      var controlDiv = document.createElement("div");
      controlDiv.style.margin = "25px";
      controlDiv.classList.add("custom-zoom");
      controlDiv.style.position = "absolute";
      controlDiv.style.bottom = "0";
      controlDiv.style.left = "0";
      controlDiv.style.zIndex = "1000";

      // Set CSS for the control wrapper
      var controlWrapper = document.createElement("div");
      controlWrapper.style.cursor = "pointer";
      controlWrapper.style.textAlign = "center";
      controlWrapper.style.width = "38px";
      controlWrapper.style.height = "90px";
      controlWrapper.style.display = "flex";
      controlWrapper.style.flexDirection = "column";
      controlWrapper.style.justifyContent = "space-between";
      controlDiv.appendChild(controlWrapper);

      // Set CSS for the zoomIn
      var zoomInButton = document.createElement("div");
      zoomInButton.style.width = "38px";
      zoomInButton.style.height = "38px";
      zoomInButton.style.backgroundImage =
        'url("' + template_url + '/app/img/plus-map.svg")';
      zoomInButton.style.backgroundSize = "contain";
      zoomInButton.style.backgroundRepeat = "no-repeat";
      zoomInButton.style.backgroundPosition = "center";
      controlWrapper.appendChild(zoomInButton);

      // Set CSS for the zoomOut
      var zoomOutButton = document.createElement("div");
      zoomOutButton.style.width = "38px";
      zoomOutButton.style.height = "38px";
      zoomOutButton.style.backgroundImage =
        'url("' + template_url + '/app/img/minus-map.svg")';
      zoomOutButton.style.backgroundSize = "contain";
      zoomOutButton.style.backgroundRepeat = "no-repeat";
      zoomOutButton.style.backgroundPosition = "center";
      controlWrapper.appendChild(zoomOutButton);

      // Setup the click event listener - zoomIn
      zoomInButton.addEventListener("click", function () {
        map.setZoom(map.getZoom() + 1);
      });

      // Setup the click event listener - zoomOut
      zoomOutButton.addEventListener("click", function () {
        map.setZoom(map.getZoom() - 1);
      });

      // Add control to map container
      var mapContainer = document.getElementById("map-wrap");
      if (mapContainer) {
        mapContainer.appendChild(controlDiv);
      }

      // Handle window resize only (removed moveend to prevent infinite loop)
      $(window).resize(function () {
        contacts.map.resize_map();
      });
    },

    resize_map: function () {
      // Prevent infinite recursion
      if (this.isResizing) {
        return;
      }
      
      this.isResizing = true;
      const windowWidth = $(window).width();
      
      if (windowWidth > 900 && this.mapInstance) {
        let containerHeight = $(".contact-page").height();
        let mapHeight = $("#map-wrap").height();
        let leafletContainer = $("#map-wrap").find(".leaflet-container");
        
        if (leafletContainer.length) {
          const topOffset = (mapHeight - containerHeight) / 2;
          leafletContainer.css({
            height: containerHeight,
            top: topOffset,
          });
        }
        
        // Trigger map resize without re-centering (to avoid infinite loop)
        this.mapInstance.invalidateSize();
      }
      
      this.isResizing = false;
    },

    render_map: function () {
      const mapEl = $("#map-wrap");
      var self = this;

      if (mapEl.data("pin")) {
        // Parse pin data if it's a JSON string
        var pinData = mapEl.data("pin");
        if (typeof pinData === 'string') {
          try {
            self.pin = JSON.parse(pinData);
          } catch (e) {
            self.pin = pinData;
          }
        } else {
          self.pin = pinData;
        }
      }

      var lat = parseFloat(mapEl.data("lat"));
      var lng = parseFloat(mapEl.data("lng"));

      if (!lat || !lng) {
        return;
      }

      // Adjust map center to shift viewport right (offset longitude to the left)
      // This makes the marker appear more centered/to the right side
      var centerOffset = 0.002; // Adjust this value to fine-tune positioning
      var mapCenter = [lat, lng - centerOffset];

      // Initialize Leaflet map
      var map = L.map("map-wrap", {
        center: mapCenter,
        zoom: self.zoom,
        zoomControl: false,
        scrollWheelZoom: false,
        dragging: true,
      });

      // Store map instance and coordinates
      // Use original marker coordinates for marker placement, but mapCenter for viewport
      self.mapInstance = map;
      self.mapCenter = mapCenter;

      // Add light grey tile layer (CartoDB Positron)
      let tileUrl = "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png";
      const cartoKey = mapEl.data("carto-key");
      if (cartoKey) {
        tileUrl += "?key=" + encodeURIComponent(cartoKey);
      }

      const tileLayer = L.tileLayer(tileUrl, {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd',
        maxZoom: 19,
      });
      
      tileLayer.addTo(map);

      // Create custom icon if pin is provided
      var customIcon = null;
      if (self.pin) {
        var pinUrl = null;
        var pinWidth = 40;
        var pinHeight = 40;
        
        if (typeof self.pin === 'object') {
          pinUrl = self.pin.url || self.pin.sizes?.full?.url || self.pin.sizes?.medium?.url;
          pinWidth = parseInt(self.pin.width || self.pin.sizes?.full?.width || self.pin.sizes?.medium?.width || 40);
          pinHeight = parseInt(self.pin.height || self.pin.sizes?.full?.height || self.pin.sizes?.medium?.height || 40);
        } else if (typeof self.pin === 'string') {
          pinUrl = self.pin;
        }
        
        if (pinUrl) {
          var iconSize = [pinWidth, pinHeight];
          var iconAnchor = [
            pinWidth / 2,
            pinHeight,
          ];

          customIcon = L.icon({
            iconUrl: pinUrl,
            iconSize: iconSize,
            iconAnchor: iconAnchor,
            popupAnchor: [0, -pinHeight],
          });
        }
      }

      // Add marker
      var markerOptions = {};
      if (customIcon) {
        markerOptions.icon = customIcon;
      }

      L.marker([lat, lng], markerOptions).addTo(map);

      // Apply custom styling
      contacts.map.applyCustomStyles();

      // Create and add custom zoom control
      contacts.map.zoomControl(map);

      // Initial resize
      setTimeout(function () {
        contacts.map.resize_map();
        map.invalidateSize();
      }, 100);
    },

    applyCustomStyles: function () {
      var style = document.createElement("style");
      style.id = 'contacts-map-custom-styles';
      var existingStyle = document.getElementById('contacts-map-custom-styles');
      if (existingStyle) {
        existingStyle.remove();
      }
      
      style.textContent = `
        .leaflet-container {
          background-color: #f5f5f5;
          font-family: inherit;
        }
        .leaflet-tile-container img {
          filter: grayscale(10%) brightness(1.02) contrast(0.98);
        }
        .leaflet-control-zoom {
          display: none;
        }
        .leaflet-marker-icon {
          z-index: 1000;
        }
      `;
      document.head.appendChild(style);
    },
  },
};

export default contacts;
